import { render, staticRenderFns } from "./blockIcon.vue?vue&type=template&id=723ff83e&"
import script from "./blockIcon.vue?vue&type=script&lang=js&"
export * from "./blockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports